import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthShell from '../components/auth/AuthShell';
import LoginForm from '../components/auth/LoginForm';

export default function LoginPage() {
  const { t } = useTranslation();
  return (
    <AuthShell testId="login-page">
      <h1 className="font-heading text-[22px] font-extrabold" data-testid="login-title">
        {t('login.title')}
      </h1>
      <p className="mb-5 mt-1 text-sm text-muted-foreground">
        {t('login.subtitle')}{' '}
        {t('login.noAccount')}{' '}
        <Link to="/register" className="text-foreground underline" data-testid="login-to-register-link">
          {t('login.createOne')}
        </Link>
      </p>
      <LoginForm />
    </AuthShell>
  );
}